import { useState, useEffect } from "react";
import SearchWorker from "./SearchTableWorker";
import GlobalSearchWorker from "./GlobalSearchWorker";
const useGlobalSearch = (columns, activeData, globalFilter) => {
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchTable, setSearchTable] = useState({
    searchTable: {},
    rawSearchTable: {},
  });
  const [filteredRows, setFilteredRows] = useState([]);

  const searchTableWorker = new Worker(SearchWorker);
  const globalSearchWorker = new Worker(GlobalSearchWorker);

  searchTableWorker.addEventListener("message", (e) => {
    setSearchTable(JSON.parse(e.data));
    setSearchLoading(false);
  });

  globalSearchWorker.addEventListener("message", (e) => {
    setFilteredRows(JSON.parse(e.data)?.presentColumns);
    setSearchLoading(false);
  });

  const globalFilterFunction = (value) => {
    setSearchLoading(true);
    globalSearchWorker.postMessage({
      value: value,
      searchTable: searchTable?.searchTable,
    });
  };
  const truearray = [];

  const filterOutFunction = (row, columnId, value, addMeta) => {
    console.log(
      row,
      "row inside",
      columnId,
      value,
      searchTable.rawSearchTable[row.id][columnId],
      truearray.length,
      truearray
    );
    if (Object.keys(searchTable.rawSearchTable).length > 0) {
      const isExistingInValue = value.findIndex(
        (el) =>
          el?.trim()?.toLowerCase() ===
          searchTable.rawSearchTable[row.id][columnId]?.trim().toLowerCase()
      );
      if (isExistingInValue !== -1) {
        truearray.push(1);
      } else {
        truearray.push(searchTable.rawSearchTable[row.id][columnId]);
      }
      return isExistingInValue !== -1;
    } else {
      return true;
    }
  };
  useEffect(() => {
    globalFilterFunction(globalFilter);
  }, [globalFilter]);

  useEffect(() => {
    const data = JSON.stringify({
      columns: columns,
      activeData: activeData,
    });
    if (activeData.length > 0 && columns.length > 0) {
      setSearchLoading(true);
      searchTableWorker.postMessage(data);
      console.log(activeData, "activeData");
    }
  }, [activeData, columns]);

  return {
    searchLoading,
    globalFilterFunction,
    filterOutFunction,
    filteredRows,
  };
};
export default useGlobalSearch;
